// extracted by mini-css-extract-plugin
export var externalLink = "_9h-0";
export var internalLinkLabel = "_9h-1";